import React, { useEffect } from 'react';
import ClipboardJS from 'clipboard';
import toast from 'lib/utils/toast';
import { report } from 'lib/utils/dataReport';
import { ATTA_CDKEY_DIALOG } from 'lib/constants/atta';
import { showIndependentModal } from '../Modal';
import IndependentDialog from '../IndependentDialog';
import './index.scss';

interface DebrisDetailDialogProps {
  redeemCode: string;
  redeemNo: string;
  callback?: () => void;
  closeModal?: () => void;
}

const CdkeyDialog = ({ redeemCode, redeemNo, callback, closeModal }: DebrisDetailDialogProps) => {
  useEffect(() => {
    report(ATTA_CDKEY_DIALOG.SHOW);
  }, []);

  return (
    <IndependentDialog title="恭喜获得京东卡" showConfirm={false} closeModal={closeModal}>
      <div className="cdkey-modal">
        <div className="cdkey-modal__code">卡号：{redeemNo}</div>
        <br />
        <div className="cdkey-modal__code">卡密：{redeemCode}</div>
        <div className="cdkey-modal__tip">
          请 <i style={{ color: '#FFF268' }}>复制</i> 后前往京东-京东E卡兑换
        </div>
        <div
          className="btn"
          onClick={() => {
            report(ATTA_CDKEY_DIALOG.COPY);
            ClipboardJS.copy(redeemCode);
            toast.info(
              <div style={{ textAlign: 'center' }}>
                复制成功～ <br /> 请前往京东使用卡密
              </div>,
            );
            callback?.();
          }}
        >
          点击复制卡密
        </div>
      </div>
    </IndependentDialog>
  );
};

export const showCdkeyDialog = ({ redeemCode, redeemNo, callback }: DebrisDetailDialogProps) =>
  showIndependentModal(<CdkeyDialog redeemCode={redeemCode} redeemNo={redeemNo} callback={callback} />);
